export class ConfirmationModalConfig {

  content: string;
  cancel: string;
  confirm: string;
  title: string;
  closed: (value: any) => void;

  constructor(
    content?: string,
    cancel?: string,
    confirm?: string,
    title?: string,
    closed?: (value: any) => void
  ) {
    this.content = content;
    this.cancel = cancel;
    this.confirm = confirm;
    this.title = title;
    this.closed = closed;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal-config.ts